import { render, staticRenderFns } from "./NotificationsBlock.vue?vue&type=template&id=916fa32c&scoped=true&"
import script from "./NotificationsBlock.vue?vue&type=script&lang=js&"
export * from "./NotificationsBlock.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBlock.vue?vue&type=style&index=0&id=916fa32c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916fa32c",
  null
  
)

export default component.exports